// Overrides an issue where ckeditor modals will not work within a bootstrap modal
// Found on https://gist.github.com/Reinmar/b9df3f30a05786511a42#gistcomment-3088738
$.fn.modal.Constructor.prototype._enforceFocus = function () {
    $(document).off('focusin.bs.modal').on('focusin.bs.modal', $.proxy((function (e) {
        if (typeof this.$element !== 'undefined' &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length &&
            !$(e.target).closest('.cke_dialog, .cke').length) {
            this.$element.trigger('focus');
        }
    }), this));
};
